import { t } from 'i18next'


const Count = ({ itemsCount }) => {
  return <>{t('common.itemsFound', { count: itemsCount })}</>
}

export default Count
